import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";

const RajaReceiptGrid = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [appliedSearch, setAppliedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [gridData, setGridData] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelUnqId, setCancelUnqId] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [reasonList, setReasonList] = useState([]);
  const [filteredReasons, setFilteredReasons] = useState([]);
  const totalPages = Math.ceil(gridData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = gridData.slice(startIndex, startIndex + pageSize);

  /* ================= STYLES ================= */
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },

    modal: {
      width: "520px",
      background: "#fff",
      borderRadius: "6px",
      overflow: "hidden",
      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    },

    header: {
      background: "#8B1E3F",
      color: "#fff",
      padding: "10px 15px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: "bold",
    },

    body: {
      padding: "15px",
    },

    row: {
      display: "flex",
      alignItems: "flex-start",
      marginBottom: "10px",
      gap: "10px",
    },

    input: {
      padding: "6px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      width: "100%",
    },

    footer: {
      padding: "10px",
      display: "flex",
      gap: "10px",
      justifyContent: "flex-start",
    },

    saveBtn: {
      padding: "6px 14px",
      border: "1px solid #1976d2",
      background: "#fff",
      color: "#1976d2",
      cursor: "pointer",
    },

    closeBtn2: {
      padding: "6px 14px",
      background: "#f44336",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    },

    closeBtn: {
      background: "transparent",
      border: "none",
      color: "#fff",
      cursor: "pointer",
      fontSize: "16px",
    },

    plusBtn: {
      padding: "6px 10px",
      border: "1px solid #333",
      background: "#fff",
      cursor: "pointer",
    },
  };

  const styles = {
    pageContainer: {
      width: "100%",
      minHeight: "100vh",
      backgroundColor: "#f4f6f8",
      padding: "10px",
      boxSizing: "border-box",
    },

    container: {
      width: "100%",
      backgroundColor: "#fff",
      padding: "15px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    },

    header: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "10px",
      marginBottom: "10px",
    },

    leftHeader: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "8px",
      flex: 1,
    },

    title: {
      fontSize: "1.1rem",
      fontWeight: "bold",
      whiteSpace: "nowrap",
    },

    searchInput: {
      minWidth: "70%",
      padding: "8px",
      border: "1px solid #ccc",
      borderRadius: "4px",
    },

    searchButton: {
      padding: "8px 14px",
      backgroundColor: "#2196F3",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },

    select: {
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },

    addButton: {
      padding: "8px 16px",
      backgroundColor: "#3a28a0",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },

    tableWrapper: {
      width: "100%",
      overflowX: "auto",
    },

    table: {
      width: "100%",
      minWidth: "1450px",
      borderCollapse: "collapse",
    },

    th: {
      backgroundColor: "#8B1E3F",
      color: "#fff",
      padding: "10px",
      border: "1px solid #ddd",
      fontSize: "0.85rem",
      whiteSpace: "nowrap",
      textAlign: "center",
    },

    td: {
      padding: "8px",
      border: "1px solid #ddd",
      fontSize: "0.85rem",
      whiteSpace: "nowrap",
      textAlign: "center",
    },

    actionBtn: (bg) => ({
      padding: "5px 10px",
      marginRight: "5px",
      backgroundColor: bg,
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      fontSize: "0.75rem",
    }),

    pagination: {
      marginTop: "12px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      fontSize: "0.9rem",
    },

    pageBtn: {
      padding: "6px 12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      backgroundColor: "#f9f9f9",
      cursor: "pointer",
    },
  };
  //---------------------FETCH GRID DATA CODE
  useEffect(() => {
    fetchGrid();
  }, []);
  const fetchGrid = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/grid",
        {
          method: "POST",
          body: JSON.stringify({
            branchUnq: "A3424899-5A58-4293-B3BF-72E3F7AF7232",
            userRoleUnq: "4848C835-2A09-4A80-A7E2-383C95926C54",
          }),
        },
      );
      const data = await response.json();
      if (data.err === "0") setGridData(data.list || []);
    } catch (err) {
      console.error("Grid load error", err);
    }
  };
  //---------------------FETCH SEARCH DATA CODE
  const handleSearch = async () => {
    try {
      const response = await apiFetch(
        "/api/receipt/search",
        {
          method: "POST",
          body: JSON.stringify({
            searchText,
            branchUnq: "A3424899-5A58-4293-B3BF-72E3F7AF7232",
            userRoleUnq: "4848C835-2A09-4A80-A7E2-383C95926C54",
          }),
        },
      );
      const data = await response.json();
      if (data.err === "0") {
        setGridData(data.list || []);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error("Search error", err);
    }
  };
  //---------------------FETCH PRINT DATA CODE
  const handlePrint = async (uniqid) => {
    try {
      const response = await apiFetch(
        "/api/receipt/print-pdf",
        { method: "POST", body: JSON.stringify({ rcl_2: uniqid }) },
      );
      if (!response.ok) {
        const errText = await response.text();
        console.error("PDF API ERROR:", errText);
        alert("PDF generation failed. Check backend logs.");
        return;
      }
      const blob = await response.blob();
      if (blob.type !== "application/pdf") {
        console.error("Not a PDF:", blob);
        alert("Invalid PDF received");
        return;
      }
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    } catch (err) {
      console.error("PRINT ERROR:", err);
      alert("Unable to print receipt");
    }
  };
  //---------------------POPUP REASON FETCH
  useEffect(() => {
    if (showCancelModal) {
      apiFetch("/api/receipt/reason", {
        method: "POST",
        body: JSON.stringify({}),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.err === "0") setReasonList(data.list || []);
        });
    }
  }, [showCancelModal]);
  //---------------------REASON AUTOCOMPLETE FILTER
  const handleReasonChange = (value) => {
    setCancelReason(value);
    if (!value) {
      setFilteredReasons([]);
      return;
    }
    setFilteredReasons(
      reasonList.filter((r) =>
        r.value.toLowerCase().includes(value.toLowerCase()),
      ),
    );
  };

  return (
    <Layout>
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          {/* ================= HEADER ================= */}
          <div style={styles.header}>
            <div style={styles.leftHeader}>
              <div style={styles.title}>RECEIPT GRID</div>

              <input
                type="text"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={styles.searchInput}
              />

              <button style={styles.searchButton} onClick={handleSearch}>
                Search
              </button>

              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={styles.select}
              >
                {[10, 20, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    {size} / page
                  </option>
                ))}
              </select>
            </div>

            <button
              style={styles.addButton}
              onClick={() => navigate("/RajaReceipt")}
            >
              Add New
            </button>
          </div>

          {/* ================= TABLE ================= */}
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Date</th>
                  <th style={styles.th}>Receipt No</th>
                  <th style={styles.th}>Customer Name</th>
                  <th style={styles.th}>Receipt Type</th>
                  <th style={styles.th}>Net Amount</th>
                  <th style={styles.th}>Received Amount</th>
                  <th style={styles.th}>Ex Showroom</th>
                  <th style={styles.th}>Other Amount</th>
                  <th style={styles.th}>Total Amount</th>
                  <th style={styles.th}>Refund Amount</th>
                  <th style={styles.th}>Due Amount</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((row, index) => (
                    <tr key={index}>
                      <td style={styles.td}>{row.Rcl_7}</td>
                      <td style={styles.td}>{row.Rcl_9}</td>
                      <td style={styles.td}>{row.Rcl_11}</td>
                      <td style={styles.td}>{row.Rcl_66}</td>
                      <td style={styles.td}>{row.Rcl_12}</td>
                      <td style={styles.td}>{row.Rcl_58}</td>
                      <td style={styles.td}>{row.Rcl_44}</td>
                      <td style={styles.td}>{row.Rcl_50}</td>
                      <td style={styles.td}>{row.Rcl_51}</td>
                      <td style={styles.td}>{row.Rcl_59}</td>
                      <td style={styles.td}>{row.Rcl_60}</td>
                      <td style={styles.td}>
                        <button
                          style={styles.actionBtn("#4CAF50")}
                          onClick={() =>
                            navigate("/RajaReceipt", {
                              state: { unqid: row.Rcl_2 },
                            })
                          }
                        >
                          Edit
                        </button>
                        <button
                          style={styles.actionBtn("#1a1c96")}
                          onClick={() => handlePrint(row.Rcl_2)}
                        >
                          Print
                        </button>

                        <button
                          style={styles.actionBtn("#f44336")}
                          onClick={() => {
                            setCancelUnqId(row.Rcl_2);
                            setCancelReason("");
                            setShowCancelModal(true);
                          }}
                        >
                          Cancel
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={12}
                      style={{ ...styles.td, textAlign: "center" }}
                    >
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {showCancelModal && (
            <div style={modalStyles.overlay}>
              <div style={modalStyles.modal}>
                {/* HEADER */}
                <div style={modalStyles.header}>
                  <span>Cancel Booking</span>
                  <button
                    style={modalStyles.closeBtn}
                    onClick={() => setShowCancelModal(false)}
                  >
                    ✖
                  </button>
                </div>

                {/* BODY */}
                <div style={modalStyles.body}>
                  <div style={modalStyles.row}>
                    <label>Date</label>
                    <input
                      type="text"
                      value={new Date().toISOString().split("T")[0]}
                      readOnly
                      style={modalStyles.input}
                    />
                  </div>

                  <div style={modalStyles.row}>
                    <label>Reason</label>
                    <div style={{ position: "relative", width: "100%" }}>
                      <input
                        type="text"
                        value={cancelReason}
                        onChange={(e) => handleReasonChange(e.target.value)}
                        autoComplete="off"
                        style={modalStyles.input}
                      />

                      {filteredReasons.length > 0 && (
                        <div
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: 0,
                            right: 0,
                            background: "#fff",
                            border: "1px solid #ccc",
                            maxHeight: "140px",
                            overflowY: "auto",
                            zIndex: 2000,
                          }}
                        >
                          {filteredReasons.map((r, i) => (
                            <div
                              key={i}
                              style={{
                                padding: "6px 10px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                              }}
                              onClick={() => {
                                setCancelReason(r.value);
                                setFilteredReasons([]);
                              }}
                            >
                              {r.value}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* FOOTER */}
                <div style={modalStyles.footer}>
                  <button
                    style={modalStyles.saveBtn}
                    onClick={async () => {
                      if (!cancelReason.trim()) {
                        alert("Please enter cancel reason");
                        return;
                      }

                      try {
                        const response = await apiFetch(
                          "/api/receipt/cancel",
                          {
                            method: "POST",
                            body: JSON.stringify({
                              rcl_2: cancelUnqId,
                              reason: cancelReason,
                              cancelDate: new Date().toISOString(),
                            }),
                          },
                        );
                        const data = await response.json();
                        if (data.err === "0") {
                          alert(data.msg);
                          setShowCancelModal(false);
                          fetchGrid();
                        } else {
                          alert(data.msg);
                        }
                      } catch (err) {
                        console.error("Cancel Save Error:", err);
                        alert("Cancel failed");
                      }
                    }}
                  >
                    Save
                  </button>

                  <button
                    style={modalStyles.closeBtn2}
                    onClick={() => setShowCancelModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* ================= PAGINATION ================= */}
          <div style={styles.pagination}>
            <button
              style={styles.pageBtn}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            <span>
              Page {currentPage} of {totalPages || 1}
            </span>

            <button
              style={styles.pageBtn}
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RajaReceiptGrid;
